import { FilterType } from '@/models';
import { FilterState } from '@/types/filter';

export const cleanFilterState = (filters: FilterState): FilterState => {
  const result: FilterState = {};

  // These filters are excluded because their values are fixed in the chart component
  // and should not influence filtering logic or comparison operations.
  const IGNORED_KEYS: FilterType[] = [FilterType.DATE_RANGE, FilterType.COMPARISON_PERIOD, FilterType.SINGLE_DATE];

  Object.entries(filters).forEach(([key, value]) => {
    const isEmpty =
      value == null ||
      value === false ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === 'string' && value.trim() === '');

    if (!isEmpty && !IGNORED_KEYS.includes(key as FilterType)) {
      result[key as keyof FilterState] = value;
    }
  });

  return result;
};
